import TeacherService from "../services/TeacherService";
import { LIST_PAGE_SIZE } from "../constants/listPagination";

const names = new Map();

export function rememberClass(item) {
  if (!item || item.id == null) return;
  names.set(String(item.id), item.name || String(item.id));
}

export function cachedClassName(classId) {
  return names.get(String(classId));
}

export function clearClassDirectory() {
  names.clear();
}

export async function loadClasses({ search, skip } = {}) {
  const res = await TeacherService.getClasses({
    search: search || undefined,
    limit: LIST_PAGE_SIZE,
    skip: skip || 0
  });
  const items = (res && res.items) || (Array.isArray(res) ? res : []);
  items.forEach(rememberClass);
  const total =
    res && typeof res.total === "number" ? res.total : items.length;
  return { items, total };
}

export async function ensureClassName(classId) {
  const cached = cachedClassName(classId);
  if (cached) return cached;

  try {
    const { items } = await loadClasses({ search: String(classId), skip: 0 });
    const found = items.find(item => String(item.id) === String(classId));
    if (found) return found.name;
  } catch (error) {
    return String(classId);
  }
  return String(classId);
}
